// import './dist/cool-mobile-ui.common'
export { default } from './dist/main/cool-mobile-ui.umd';
export * from './dist/main/cool-mobile-ui.umd';
import './dist/main/cool-mobile-ui.css';
